import { Captions } from "@vidstack/react";
import React from "react";
import { usePlayerLayoutContext } from "@/components/player/layouts/PlayerLayoutContext";
import "@/styles/player/captions.css";
export function BraivCaptions({
  ...props
}) {
  const {
    captionStyle
  } = usePlayerLayoutContext();
  return <Captions className={`vds-captions vds-captions-${captionStyle}`} data-sentry-element="Captions" data-sentry-component="BraivCaptions" data-sentry-source-file="captions.tsx" />;
}